var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28292 1.05599C8.14129 -0.352001 10.1951 -0.351993 11.0535 1.05599L11.0941 1.12525L12.9186 4.36234L16.561 5.09722C18.2492 5.43783 18.9168 7.49255 17.7513 8.76038L15.2365 11.4958L15.6631 15.1872C15.8608 16.898 14.113 18.1679 12.5471 17.4513L9.16821 15.9047L5.78933 17.4513C4.2234 18.1679 2.47559 16.898 2.67331 15.1872L3.09973 11.4958L0.58508 8.76038C-0.580408 7.49254 0.0872663 5.43783 1.77539 5.09722L5.41766 4.36234L7.24233 1.12525L7.28292 1.05599Z",
    fill: "#FFCE09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58024 2.15499C8.85083 1.6749 9.54218 1.6749 9.81277 2.15499L11.732 5.55999C11.8329 5.73909 12.0068 5.86542 12.2083 5.90608L16.0397 6.67914C16.5799 6.78814 16.7936 7.44565 16.4206 7.85135L13.7753 10.7288C13.6362 10.8802 13.5698 11.0846 13.5934 11.2888L14.0421 15.1716C14.1054 15.719 13.5461 16.1254 13.045 15.8961L9.49091 14.2694C9.30396 14.1839 9.08905 14.1839 8.9021 14.2694L5.34803 15.8961C4.84692 16.1254 4.28762 15.719 4.35089 15.1716L4.79963 11.2888C4.82323 11.0846 4.75682 10.8802 4.61768 10.7288L1.9724 7.85135C1.59943 7.44565 1.81306 6.78814 2.35327 6.67914L6.18469 5.90608C6.38622 5.86542 6.56009 5.73909 6.66104 5.55999L8.58024 2.15499Z",
    fill: "#FFE475"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRounded);
export default __webpack_public_path__ + "static/media/star-rounded.da124a5e16b967954d431877b689b915.svg";
export { ForwardRef as ReactComponent };